import { slider } from '../../utils/slider';

const SLIDER_CLASSNAME = '.c-section-divider__navigation-inner';

export const init = ($sectionDividerSpecial) => {
  const $sectionDividerSpecialSlider = $sectionDividerSpecial.querySelector(SLIDER_CLASSNAME);
  slider($sectionDividerSpecialSlider);
};
